/**
 * Calculates the corners of a rectangle based on its DOMRect and an offset.
 *
 * @internal
 */ export function pointsToSvgPath(points) {
    return `M ${points} z`;
}
